import { TourConfig, TourHandle, useFeatureTour } from '@app/core/tours/useFeatureTour';
import { defineMessage, useIntl } from 'react-intl';

/**
 * Runs the one-time tour for the status view toggle (list/grid switch) if not yet seen and before expiry.
 */
export function useStatusViewToggleTour(): TourHandle {
  const { $t } = useIntl();

  return useFeatureTour({ key: 'loggerStatusViewToggle', expiry: '2026-03-22' }, {
    steps: [
      {
        element: '#logger-status-view-toggle',
        popover: {
          title: $t(
            defineMessage({
              id: 'logger.statusScreen.tour.viewToggle.title',
              defaultMessage: 'Vista de emisoras',
            }),
          ),
          description: $t(
            defineMessage({
              id: 'logger.statusScreen.tour.viewToggle.description',
              defaultMessage:
                'Cambia entre lista y grilla (amplia, normal o compacta) para ver las emisoras como prefieras.',
            }),
          ),
          side: 'left',
          align: 'center',
        },
      },
    ],
  } satisfies TourConfig);
}
